export function genericActionCreator<T, P = void>(
	type: T,
): (payload: P) => { type: T; payload: P } {
	return (payload: P) => ({
		type,
		payload,
	});
}
